import React from 'react'
import { FadeIn, Spinner } from 'lib/ui/components'
import { useReviews } from 'lib/core/hooks'
import { RatingStars } from 'components/Reviews/components/RatingStars'
import { useReviewsContext } from 'components/Reviews'
import { Button } from 'lib/ui/components/Button'
import { ReviewList } from './components/ReviewList'
import { ReviewHeader, Summary } from './components/Styled'

interface Prop {
  productId: number
}

export const WriteReview: React.FC<Prop> = ({ productId }) => {
  const { reviewList, isLoading } = useReviews(productId)
  const { openModal, reviewsCount, ratingAverage } = useReviewsContext()
  const reviewString = reviewsCount === 1 ? 'Review' : 'Reviews'

  return (
    <>
      <h2>
        Reviews
      </h2>
      {isLoading ? (
        <Spinner />
      ) : (
        <FadeIn>
          <Summary>
            <div className='rating__average'>
              {reviewsCount < 1 && (
                <p>Be the first to write a customer review</p>
              )}
              <RatingStars
                ratingPercentage={ratingAverage}
              />
              <p>{reviewsCount} {reviewString}</p>
            </div>
            <ReviewHeader>
              <div className='rating__action'>
                <Button
                  variant='primary'
                  onClick={openModal}
                >
                  {reviewsCount > 0 ? 'Add your Review' : 'Write a Review'}
                </Button>
              </div>
            </ReviewHeader>
          </Summary>
          {/* {reviewsCount > 0 && ( */}
          <ReviewList
            reviewList={reviewList}
            reviewsCount={reviewsCount}
          />
          {/* )} */}
        </FadeIn>
      )}
    </>
  )
}
